import React from 'react';

import { Box, Button, Typography } from '@mui/material';

import SvgIcon from '../../../components/Icons';
import { Link } from 'react-router-dom';

export const PurchasePostsCard = () => {
  return (
    <Box>
      <Box
        component={'img'}
        src={'/png/posts-content.png'}
        alt='posts-content'
        maxWidth={'100%'}
        height={'auto'}
      />
      <Typography color='#222' fontSize={'15px'} mt={'20px'} mb={'23px'}>
        Upgrade your plan to view the posts you received on Instagram
      </Typography>
      <Button
        component={Link}
        to='/plans'
        id='btn-premium-plans'
        startIcon={<SvgIcon name='Plus' sx={{ fill: 'url(#linear-gradient)' }} />}
        variant='contained'
        color='primary'
        fullWidth
        sx={{ py: 1.5 }}
      >
        Upgrade plan
      </Button>
    </Box>
  );
};
